import {
  protectedAxiosInstance,
  unprotectedAxiosInstance,
} from "./axiosManagement";

export const getOrderList = (params) => {
  return protectedAxiosInstance
    .get("/admin/orders", { params })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const postOrderItem = (id, payload) => {
  return protectedAxiosInstance
    .post(`/admin/orders/${id}/items`, payload)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const getSingleOrderDetails = (id, params) => {
  return protectedAxiosInstance
    .get(`/admin/orders/${id}`, { params })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const getOrderTimeline = (id, params) => {
  return protectedAxiosInstance
    .get(`/admin/orders/${id}/activity-log`, { params })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const getOrderItems = (id) => {
  return protectedAxiosInstance
    .get(`/admin/orders/${id}/items`)
    .then((res) => res.data)
    .catch((error) => {
      throw error;
    });
};

export const updateOrderItem = (orderId, itemId, payload) => {
  return protectedAxiosInstance
    .patch(`/admin/orders/${orderId}/items/${itemId}`, payload)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const updateSpecificOrder = (orderId, payload) => {
  return protectedAxiosInstance
    .patch(`/admin/orders/${orderId}`, payload)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const deleteOrderItem = (orderId, itemId) => {
  return protectedAxiosInstance
    .delete(`/admin/orders/${orderId}/items/${itemId}`)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const submitTimeline = (orderId) => {
  return protectedAxiosInstance
    .get(`/admin/orders/${orderId}/submit-timeline`)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const postOrderDraft = (payload) => {
  return protectedAxiosInstance
    .post("/admin/orders/create-draft", payload)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

// export const updateOrder = (id, payload) => {
//   return protectedAxiosInstance
//     .put(`/admin/products/category/${id}`, payload)
//     .then((response) => response.data)
//     .catch((error) => {
//       throw error;
//     });
// };

// export const deleteProductCategory = (id) => {
//   return protectedAxiosInstance
//     .delete(`/admin/products/category/${id}`)
//     .then((response) => response.data)
//     .catch((error) => {
//       throw error;
//     });
// };

export const getOrderStatusSummary = (params) => {
  return protectedAxiosInstance
    .get("/admin/orders/status-summary", { params })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const getOrderAppConfig = (params) => {
  return unprotectedAxiosInstance
    .get("/admin/app-config", { params })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const getCustomersAddressList = (customerID) => {
  return protectedAxiosInstance
    .get(`/admin/accounts/customers/${customerID}/address`)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const assignedChannelPartner = (orderId, payload) => {
  return protectedAxiosInstance
    .post(`/admin/orders/${orderId}/re-assign-channel-partner`, payload)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const updateTimelineBulk = (orderId, payload) => {
  return protectedAxiosInstance
    .post(`/admin/orders/${orderId}/items/bulk-update`, payload)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const getShareableToken = (orderId) => {
  return protectedAxiosInstance
    .post(`/admin/orders/${orderId}/generate-shareable-token`)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const uploadInvoice = (orderId, payload) => {
  return protectedAxiosInstance
    .post(`/admin/orders/${orderId}/invoice`, payload)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const getInvoice = (orderId) => {
  return protectedAxiosInstance
    .get(`/admin/orders/${orderId}/invoice`)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const getSingleOrderItem = (orderId, itemId) => {
  return protectedAxiosInstance
    .get(`/admin/orders/${orderId}/items/${itemId}`)
    .then((res) => res.data)
    .catch((error) => {
      throw error;
    });
};

export const getPaymentLogs = (orderId) => {
  return protectedAxiosInstance
    .get(`/admin/orders/${orderId}/payment-logs`, { params: { length: 500 } })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const recordPayment = (orderId, payload) => {
  return protectedAxiosInstance
    .post(`/admin/orders/${orderId}/record-payment`, payload)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const getDispatchList = (orderId) => {
  return protectedAxiosInstance
    .get(`/admin/orders/${orderId}/dispatch`, { params: { length: 500 } })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const createDispatch = (orderId, payload) => {
  return protectedAxiosInstance
    .post(`/admin/orders/${orderId}/dispatch/create`, payload)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const updateDispatch = (orderId, dispatchId, payload) => {
  return protectedAxiosInstance
    .put(`/admin/orders/${orderId}/dispatch/${dispatchId}`, payload)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const markAsDelivered = (orderId, dispatchId) => {
  return protectedAxiosInstance
    .get(`/admin/orders/${orderId}/dispatch/${dispatchId}/mark-delivered`)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const cancelOrder = (orderId) => {
  return protectedAxiosInstance
    .post(`/admin/orders/${orderId}/cancel-order`)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const confirmOrder = (orderId) => {
  return protectedAxiosInstance
    .post(`/admin/orders/${orderId}/confirm-order`)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const placeOrder = (orderId) => {
  return protectedAxiosInstance
    .post(`/admin/orders/${orderId}/place-order`)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
